module.exports = __webpack_public_path__ + "static/homecharging-65c56f70b80a847f1e2adfd03a0765d5.jpg";